import { render, staticRenderFns } from "./DebtorAdd.vue?vue&type=template&id=7df11e28&"
import script from "./DebtorAdd.vue?vue&type=script&lang=js&"
export * from "./DebtorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports